import { render, staticRenderFns } from "./TicketCounterGeneral.vue?vue&type=template&id=5b4575ba&scoped=true&"
import script from "./TicketCounterGeneral.vue?vue&type=script&lang=js&"
export * from "./TicketCounterGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4575ba",
  null
  
)

export default component.exports